export default __webpack_public_path__ + "static/media/barley_stage.c23eef98.png";